const requestInit = {
  method: "get",
  headers: {
    "Content-Type": "application/json"
  }
};

export const channelLookupByDma = async (rootURL: string, dma: number) => {
  const url = `${rootURL}neighbouring/dma/${dma}`;
  let result = await fetch(url, requestInit);
  result = await result.json();
  return result;
};

export const channelLookupByZipcode = async (rootURL: string, zipcode: string) => {
  const url = `${rootURL}neighbouring/zipcode/${zipcode}`;
  let result = await fetch(url, requestInit);
  result = await result.json();
  return result;
};

export const channelLookupByCallSign = async (rootURL: string, callSign: string) => {
  const url = `${rootURL}neighbouring/call/sign/${callSign}`;
  let result = await fetch(url, requestInit);
  result = await result.json();
  return result;
};
